import { createSlice } from "@reduxjs/toolkit";

const productManagementSlice = createSlice({
    name: "productManagement",
    initialState: {
        isLoading: false,
        productList: [],
    },
    reducers: {
        setIsLoading(state, action) {
            state.isLoading = action.payload;
        },
        setProductList(state, action) {
            state.productList = action.payload;
        },
    },
});

export const {
    setIsLoading,
    setProductList,
} = productManagementSlice.actions;
export default productManagementSlice.reducer;
